import React from "react";
import { RefreshIcon } from "../Auth/onboarding/icons";
import { EyeIcon, SaveIcon } from "./icons";

export default function ActionBar({
  onReset,
  onPreview,
  onSave,
  saved,
  saving = false,
  disabled = false,
}) {
  return (
    <div className="cz-action-bar">
      <div className="cz-action-bar-left">
        <button
          type="button"
          className="onboarding__btn onboarding__btn--secondary"
          onClick={onReset}
          disabled={disabled || saving}
        >
          <RefreshIcon />
          Reset
        </button>
        <button type="button" className="onboarding__btn onboarding__btn--secondary" onClick={onPreview}>
          <EyeIcon />
          Preview
        </button>
      </div>
      <button
        type="button"
        className="onboarding__btn onboarding__btn--primary cz-save-btn"
        onClick={onSave}
        disabled={disabled || saving}
      >
        <SaveIcon />
        {saving ? "Saving..." : saved ? "Saved!" : "Save changes"}
      </button>
    </div>
  );
}
